import { subTypes } from "../itemTypes";
import InputChoice from "./InputChoice";
import StaticChoice from "./StaticChoice";

export default function Choice(props) {
  const {
    question: { type, options },
  } = props;
  switch (type) {
    case subTypes.singleChoice:
    case subTypes.multipleChoice:
    case subTypes.likert:
    case subTypes.order:
      return <InputChoice {...props} />;

    case subTypes.yesno:
    case subTypes.multiSmiley:
    case subTypes.bodyParts:
    default:
      return <StaticChoice type={type} options={options} />;
  }
}
